import { SignIn, SignedIn, SignedOut } from "@clerk/clerk-react";
import { Navigate, createRoute } from "@tanstack/react-router";
import { rootRoute } from "./root";
import styles from "./sign-in.module.scss";

function SignInScreen() {
  return (
    <>
      <SignedIn>
        <Navigate to="/" />
      </SignedIn>
      <SignedOut>
        <main className={styles.root}>
          <SignIn routing="hash" signUpUrl="/sign-in" />
        </main>
      </SignedOut>
    </>
  );
}

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign-in",
  component: SignInScreen,
});
